import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium text-neutral-600" }, [
  /*#__PURE__*/_createTextVNode("Please fill out all the required fields with the red asterisk ("),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-600" }, "*"),
  /*#__PURE__*/_createTextVNode(")")
], -1)
const _hoisted_3 = { class: "grid grid-cols-2 gap-6 mt-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 border-t border-gray-200" }, null, -1)
const _hoisted_5 = { class: "col-span-2" }
const _hoisted_6 = { class: "col-span-2" }
const _hoisted_7 = { class: "col-span-2" }
const _hoisted_8 = { class: "col-span-2" }
const _hoisted_9 = { class: "col-span-2" }

import { ref, onMounted } from 'vue';
import SectionTitle from '@/components/partials/SectionTitle.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import MultiSelect from "@/components/inputs/MultiSelect.vue";

import {
    LocationDataInterface,
    SelectInterface
} from "@/interfaces/Settings/LocationInterface"

import DropdownService from "@/classes/Dropdowns/DropdownService";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormSection',
  props: {
    form: {
        type: Object as () => LocationDataInterface,
        defualt: [],
        required: true,
    },
    errors: {
        type: Object,
        defualt: [],
        required: true,
    },
},
  setup(__props) {

const props = __props;


const form = ref<LocationDataInterface>(props.form);
const regionOptions = ref<SelectInterface>([])
const provinceOptions = ref<SelectInterface>([])
const cityOptions = ref<SelectInterface>([])

const getRegions = ():void => {
    DropdownService
        .regions()
        .then(({data}) => {
            regionOptions.value = data;
        })
}

const getProvince = ():void => {
    if(form.value.region_id){
        DropdownService
            .provinces(form.value.region_id)
            .then(({data}) => {
                provinceOptions.value = data;
            })
    }
}

const getCity = ():void => {
    if(form.value.province_id){
        DropdownService
            .cities(form.value.province_id)
            .then(({data}) => {
                cityOptions.value = data;
            })
    }
}

const regionChange = ():void => {
    form.value.city_id = null
    form.value.barangay_id = null
    form.value.province_id = null
    getProvince()
}

const provinceChange = ():void => {
    form.value.city_id = null
    form.value.barangay_id = null
    getCity()
}

onMounted(() => {
    getRegions()

    if(form.value.id){
        getProvince();
        getCity();
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SectionTitle, {
      fontSmall: "",
      title: "Baranagay Information"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("form", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(TextInput, {
          type: "text",
          label: "Code",
          placeholder: "Code",
          name: "code",
          id: "code",
          modelValue: form.value.code,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.code) = $event)),
          error: __props.errors?.code,
          required: ""
        }, null, 8, ["modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(MultiSelect, {
          searchable: "",
          options: regionOptions.value,
          id: "region",
          name: "region",
          label: "Region",
          placeholder: "Select..",
          modelValue: form.value.region_id,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => ((form.value.region_id) = $event)),
            _cache[2] || (_cache[2] = ($event: any) => (regionChange()))
          ],
          error: __props.errors?.region_id,
          required: ""
        }, null, 8, ["options", "modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(MultiSelect, {
          searchable: "",
          options: provinceOptions.value,
          id: "Province",
          name: "Province",
          label: "Province",
          placeholder: "Select..",
          modelValue: form.value.province_id,
          "onUpdate:modelValue": [
            _cache[3] || (_cache[3] = ($event: any) => ((form.value.province_id) = $event)),
            _cache[4] || (_cache[4] = ($event: any) => (provinceChange()))
          ],
          error: __props.errors?.province_id,
          required: ""
        }, null, 8, ["options", "modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(MultiSelect, {
          searchable: "",
          options: cityOptions.value,
          id: "City",
          name: "City",
          label: "City",
          placeholder: "Select..",
          modelValue: form.value.city_id,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.city_id) = $event)),
          error: __props.errors?.city_id,
          required: ""
        }, null, 8, ["options", "modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(TextInput, {
          type: "text",
          label: "Name",
          placeholder: "Name",
          name: "name",
          id: "name",
          modelValue: form.value.name,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.name) = $event)),
          error: __props.errors?.name,
          required: ""
        }, null, 8, ["modelValue", "error"])
      ]),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})